import React, { useState } from "react";
import { Button, Container, Rating } from "@mui/material";
import { ArrowRightAlt } from "@mui/icons-material";

import {
  ChooseUs1,
  ChooseUs2,
  ChooseUs3,
  ChooseUs4,
  DeliveryImage,
  HomeBg1,
  HomeBg2,
  TrustLogo,
  TrustPlay,
} from "asset";
import {
  BasicCard,
  ClientReviews,
  SupplierCards,
  SliderMain,
} from "components";
import Slider from "react-slick";
import { NavLink } from "react-router-dom";
import {
  useCartData,
  useProducts,
  useSuppliers,
  useWishlistData,
} from "hooks/useDataFetch";

const Home = () => {
  const sliderData = [
    {
      img: HomeBg1,
      title: "Pure & Healthy Drinking Water ",
      desc: "Understand the importance of life",
    },
    {
      img: HomeBg2,
      title: "Pure & Healthy Drinking Water ",
      desc: "Understand the importance of life",
    },
  ];

  const ClientTrust = [
    {
      title: "Trusted From Our Clients",
      desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nobis odit, maxime dolores, at enim soluta omnis alias eum minima cum suscipit mollitia.",
    },
    {
      title: "Trusted From Our Clients",
      desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nobis odit, maxime dolores, at enim soluta omnis alias eum minima cum suscipit mollitia.",
    },
    {
      title: "Trusted From Our Clients",
      desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nobis odit, maxime dolores, at enim soluta omnis alias eum minima cum suscipit mollitia.",
    },
  ];

  const whyChooseUs = [
    {
      icon: ChooseUs1,
      title: "Scientifically Proven Pure Water",
      desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit exercitationem adipisci sed voluptates ex eveniet nihil ipsa saepe eum aliquid.",
    },
    {
      icon: ChooseUs2,
      title: "Scientifically Proven Pure Water",
      desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit exercitationem adipisci sed voluptates ex eveniet nihil ipsa saepe eum aliquid.",
    },
    {
      icon: ChooseUs3,
      title: "Scientifically Proven Pure Water",
      desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit exercitationem adipisci sed voluptates ex eveniet nihil ipsa saepe eum aliquid.",
    },
    {
      icon: ChooseUs4,
      title: "Scientifically Proven Pure Water",
      desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit exercitationem adipisci sed voluptates ex eveniet nihil ipsa saepe eum aliquid.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    pauseOnHover: true,
    dotsClass: "slick-dots ",
    responsive: [
      {
        breakpoint: 1111,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const clientTrustSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    pauseOnHover: true,
    dotsClass: "home-client-trust-details-slider-btn slick-dots ",
  };

  const productsData = useProducts();

  const suppliersData = useSuppliers();

  const wishList = useWishlistData();

  const cartData = useCartData();

  return (
    <>
      <main className="home-main">
        <div className="home-slider-component">
          <SliderMain
            indexFn={setCurrentIndex}
            totalChildDisplay={1}
            delay={7000}
          >
            {sliderData &&
              sliderData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="slider-children"
                    style={{ backgroundImage: `url(${item.img})` }}
                  >
                    <Container>
                      <div
                        className={`slider-content ${
                          currentIndex === index && "active-slider"
                        } `}
                      >
                        <p className="slider-desc animated-desc">{item.desc}</p>
                        <h1 className="slider-heading  animated-heading ">
                          {item.title}
                        </h1>
                        <div className="slider-btn animated-btn ">
                          <NavLink to={"/ordernow"}>
                            <Button className="slider-btn-left">
                              Order Today!
                            </Button>
                          </NavLink>
                          <NavLink to={"/contact"}>
                            <Button className="slider-btn-right">
                              Free Estimate
                            </Button>
                          </NavLink>
                        </div>
                      </div>
                    </Container>
                  </div>
                );
              })}
          </SliderMain>
        </div>

        {productsData && productsData?.data?.length && (
          <section className="home-product-banner-section">
            <Container>
              <div className="home-product-banner-container">
                <div className="home-product-banner-title flex-column align-items-center">
                  <h1>Our Products</h1>
                  <p>
                    We now deliver different types of bottled water.To Drink the
                    best water please come to us and give us order and take safe
                    and sound water for you.
                  </p>
                </div>

                <div className="home-product-banner-cards  gap-1">
                  {productsData &&
                    productsData?.data?.length &&
                    productsData?.data?.map((data, index) => {
                      return (
                        <BasicCard
                          key={index}
                          inWishlist={
                            wishList?.data?.some((item) => {
                              return item?.id === data?.id;
                            }) || false
                          }
                          inCart={
                            cartData?.data?.some((item) => {
                              return item?.id === data?.id;
                            }) || false
                          }
                          data={data}
                        />
                      );
                    })}
                </div>
              </div>
            </Container>
          </section>
        )}

        {suppliersData?.data && suppliersData?.data?.length > 0 && (
          <section className="home-top-distributor-section">
            <Container>
              <div className="home-top-distributor-container  ">
                <h1 className="home-top-distributor-title">Top Suppliers</h1>
              </div>

              <Slider {...settings}>
                {suppliersData?.data?.map((data, index) => {
                  return (
                    <div
                      key={index}
                      className="home-top-distributor-child-outer flex-row justify-content-center"
                    >
                      <SupplierCards
                        id={data?.id}
                        img={data?.image}
                        name={data?.name}
                        location={data?.location}
                        rating={data?.rating}
                        minOrder={data?.minOrder}
                      />
                    </div>
                  );
                })}
              </Slider>
            </Container>
          </section>
        )}

        <section className="home-client-trust-section">
          <Container>
            <div className="home-client-trust-container flex-row flex-wrap gap-2">
              <div className="home-client-trust-rating flex-column align-items-center">
                <span className="home-client-trust-rating-logo flex-column align-items-center ">
                  <img src={TrustLogo} alt="People Trust" />
                  <p>Lorem ipsum.</p>
                </span>

                <span className="home-client-trust-rating-details">
                  <Rating name="read-only" value={5} readOnly />
                  <span className="home-client-trust-rating-number flex-column align-items-center ">
                    <h1>5.0</h1>
                  </span>
                </span>
              </div>
              <div className="flex-row align-items-center">
                <div className="trust-slider-outer">
                  <Slider {...clientTrustSliderSettings}>
                    {ClientTrust &&
                      ClientTrust.map((item, index) => {
                        return (
                          <div key={index}>
                            <div className="home-client-trust-details flex-column  justify-content-center gap-2 ">
                              <h1 className="home-client-trust-details-heading">
                                {item.title}
                              </h1>

                              <p className="home-client-trust-details-desc">
                                {item.desc}
                              </p>

                              <div className="home-client-trust-details-btn flex-row gap-2 align-items-center">
                                <Button className="home-client-trust-details-button">
                                  {" "}
                                  All Client{" "}
                                </Button>

                                <span className="flex-row gap-1 align-items-center ">
                                  {" "}
                                  <img src={TrustPlay} alt="" /> How It Works
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </Slider>
                </div>
              </div>
            </div>
          </Container>
        </section>
        <section className="home-why-us">
          <Container>
            <div className="home-why-us-container">
              <div className="home-why-us-container-title">
                <h1>Why Choose Us</h1>
                <p>
                  Another name for water is life. we want to help you to improve
                  your water quality.So that you and your family can drink pure,
                  healthy and safe water. We are trying our best to give you
                  these services.
                </p>
              </div>

              <div className="home-why-us-card-container  gap-2  justify-content-between ">
                {whyChooseUs.map((data, index) => {
                  return (
                    <div
                      className="home-why-us-card flex-row  gap-2 "
                      key={index}
                    >
                      <div className="home-why-us-card-img ">
                        <img src={data.icon} alt="Maximum Purity" />
                      </div>
                      <div className="home-why-us-card-content flex-column gap-2">
                        <h1 className="home-why-us-card-content-heading">
                          {data.title}
                        </h1>

                        <p className="home-why-us-card-content-desc">
                          {data.desc}
                        </p>

                        <span className="home-why-us-card-content-btn">
                          <Button className="flex-row gap-1">
                            Read More
                            <span className=" home-why-us-card-content-btn-span flex-row align-items-center">
                              <ArrowRightAlt />
                            </span>
                          </Button>
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Container>
        </section>

        <ClientReviews />

        <section className="home-delivery-section flex-row align-items-center ">
          <Container>
            <div className="home-delivery-container flex-row w-100 gap-2 align-items-center ">
              <div className="home-delivery-container-left flex-column align-items-center">
                <h1 className="home-delivery-container-title">
                  Water Delivery 20 k.m. Free Service
                </h1>
                <p className="home-delivery-container-desc">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Ducimus numquam quo in molestiae,Lorem ipsum dolor sit amet
                  consectetur adipisicing elit. Non, eveniet.
                </p>

                <div className="home-delivery-container-btn">
                  <Button>Read More</Button>
                </div>
              </div>
              <div className="home-delivery-container-right">
                <img src={DeliveryImage} alt="Delivery" />
              </div>
            </div>
          </Container>
        </section>
      </main>
    </>
  );
};

export default Home;
